import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'baf-startup',
  templateUrl: './startup.component.html',
  styleUrls: ['./startup.component.css']
})
export class StartupComponent implements OnInit {
  constructor() {
    console.log('Startup');
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/components/startup/startup.component.ts